import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const histogramTool: Tool = {
  id: "histogram",
  name: () => m.hist_tool_name(),
  description: () => m.hist_tool_description(),
  icon: "📊",
  basePath: "/histogram",
  status: "stable",
  tags: [
    "chart",
    "plot",
    "data-visualization",
    "histogram",
    "statistics",
    "science",
  ],
};
